import { useEffect, useState } from 'react';
import { OrientationType } from 'react-native-orientation-locker';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
export const useAirPlayButtonMargin = ({ isAppPortrait, isDesiredPlayerOrientationPortrait, desiredPlayerOrientation, }) => {
    const [airPlayButtonMargin, setAirPlayButtonMargin] = useState();
    const { top: topInset, bottom: bottomInset } = useSafeAreaInsets();
    useEffect(() => {
        if ((isDesiredPlayerOrientationPortrait)
            || (isAppPortrait
                && desiredPlayerOrientation === OrientationType['LANDSCAPE-RIGHT'])) {
            setAirPlayButtonMargin(0);
        }
        else {
            setAirPlayButtonMargin(Math.max(topInset, bottomInset));
        }
    }, [
        isAppPortrait,
        isDesiredPlayerOrientationPortrait,
        desiredPlayerOrientation,
    ]);
    return airPlayButtonMargin;
};
//# sourceMappingURL=useAirPlayButtonMargin.js.map